module.exports = __webpack_public_path__ + "img/info.99ee1589.png";